var React = require('react');

function Blog (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Document"},[React.createElement("rect",{"id":"Rectangle 74","x":"1.33337","y":"1.66687","width":"13.3333","height":"16.6667","rx":"3.33333","stroke":"#121212","strokeWidth":"1.5","key":0}),React.createElement("path",{"id":"Vector 132","d":"M4.66669 5.83337H11.3334","stroke":"#121212","strokeWidth":"1.5","strokeLinecap":"round","key":1}),React.createElement("path",{"id":"Vector 133","d":"M4.66669 10H11.3334","stroke":"#121212","strokeWidth":"1.5","strokeLinecap":"round","key":2}),React.createElement("path",{"id":"Vector 134","d":"M4.66669 14.1669H8.00002","stroke":"#121212","strokeWidth":"1.5","strokeLinecap":"round","key":3})]));
}

Blog.defaultProps = {"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none"};

module.exports = Blog;

Blog.default = Blog;
